import React from 'react';
import './loader.css';

const Loader = () => <div className="loader"></div>;

export default Loader;
